import {get} from "lodash"
import {
    DuplicatedLeadNotificationRecipientResponse,
    AddDuplicatedLeadNotificationRecipientPayload,
    DeleteDuplicatedLeadNotificationRecipientPayload,
    ListDuplicatedLeadNotificationRecipientsPayload,
    UpdateDuplicatedLeadNotificationRecipientPayload
} from "types/settings/lead-bucket-settings"
import BaseService from "./Base"

class LeadBucketSettingsService extends BaseService {
    async createAdmissionsLeadBucket(params: AddDuplicatedLeadNotificationRecipientPayload): Promise<void> {
        const response = await this.post(
            "/v1/settings/admissions/lead-bucket/duplicated-leads-notification-recipients/create",
            params
        )
        return
    }
    async listAdmissionsLeadBucket(
        params: ListDuplicatedLeadNotificationRecipientsPayload = {}
    ): Promise<DuplicatedLeadNotificationRecipientResponse> {
        const response = await this.post(
            "/v1/settings/admissions/lead-bucket/duplicated-leads-notification-recipients/list",
            params
        )
        return get(response, "data", [])
    }
    async updateAdmissionsLeadBucket(params: UpdateDuplicatedLeadNotificationRecipientPayload): Promise<void> {
        const response = await this.post(
            "/v1/settings/admissions/lead-bucket/duplicated-leads-notification-recipients/update",
            params
        )
        return
    }
    async deleteAdmissionsLeadBucket(params: DeleteDuplicatedLeadNotificationRecipientPayload): Promise<void> {
        const response = await this.post(
            "/v1/settings/admissions/lead-bucket/duplicated-leads-notification-recipients/delete",
            params
        )
        return
    }
}

export default LeadBucketSettingsService
